import athletesAsset from "@/assets/restore/chicago-athletes.webp.asset.json";
const wapoLogo = { url: "/press-logos/washington-post.webp" };
const espnLogo = { url: "/press-logos/espn.webp" };
const esquireLogo = { url: "/press-logos/esquire.webp" };
const foxLogo = { url: "/press-logos/fox-sports.webp" };
const gqLogo = { url: "/press-logos/gq.webp" };
const nbcLogo = { url: "/press-logos/nbc.webp" };

const PRESS_LOGOS = [
  { src: wapoLogo.url, alt: "The Washington Post" },
  { src: espnLogo.url, alt: "ESPN" },
  { src: esquireLogo.url, alt: "Esquire" },
  { src: foxLogo.url, alt: "FOX Sports" },
  { src: gqLogo.url, alt: "GQ" },
  { src: nbcLogo.url, alt: "NBC" },
];

export function WhyChooseChicago({
  showProsHeadline = false,
  headingTag: HeadingTag = "h2",
  city = "Chicago",
  method = "with our RESTORE® No-Shave FUE™ hair transplant method",
}: {
  /** City in the first sentence. */
  city?: string;
  /** Phrase after "a thick full head of hair". */
  method?: string;
  showProsHeadline?: boolean;
  headingTag?: "h1" | "h2";
}) {
  return (
    <section className="bg-background pt-10 md:pt-12">
      <div className="mx-auto max-w-7xl px-4 lg:px-8">
        <div className="grid gap-8 lg:grid-cols-2 lg:gap-12">
          <HeadingTag className="text-4xl font-extrabold leading-tight text-foreground md:text-5xl">
            <span className="font-light">Why Choose</span>
            <br />
            RESTORE<sup className="text-2xl">®</sup> Hair?
          </HeadingTag>
          <p className="text-base leading-relaxed text-muted-foreground md:text-lg">
            For the past 20 years, men just like you in {city} and across the United States,
            have reached out to RESTORE for a hair transplant. That's because RESTORE's team of{" "}
            <a
              href="https://restorehair.com/doctors/"
                            className="text-foreground underline hover:text-primary"
            >
              elite level hair doctors
            </a>{" "}
            can deliver a thick full head of hair {method}. At RESTORE Hair, we deliver natural and virtually undetectable results. We've
            come a long way in the world of hair restoration, and thanks to RESTORE, there's never
            been a better time to get your hair back.
          </p>
        </div>

        {showProsHeadline && (
          <h2 className="mt-8 text-center text-4xl font-extrabold leading-tight text-foreground md:text-5xl">
            The Pros Can Go Anywhere...
            <br />
            They Come to RESTORE<sup className="text-2xl">®</sup>
          </h2>
        )}

        <div className="mt-10 grid grid-cols-4 gap-2 sm:gap-4 md:gap-6">
          {[
            { name: "Eddie Olczyk", badge: "Hall of Fame Hockey Player" },
            { name: "Deion Sanders", badge: "Hall of Fame Football Player" },
            { name: "Brian Urlacher", badge: "Hall of Fame Football Player" },
            { name: "Ian Happ", badge: "Professional Baseball Player" },
          ].map(({ name, badge }) => (
            <figure key={name} className="text-center">
              <span className="hidden md:inline-block bg-[#F7E6BF] px-2 py-1 text-xs font-medium text-foreground md:text-sm">
                {badge}
              </span>
              <figcaption className="text-base font-bold text-foreground md:mt-1 md:text-lg">
                {name}
              </figcaption>
              <p className="text-xs italic text-muted-foreground md:text-sm">
                RESTORE Client
              </p>
            </figure>
          ))}
        </div>

        <img
          src={athletesAsset.url}
          alt="Eddie Olczyk, Deion Sanders, Brian Urlacher, and Ian Happ — RESTORE Hair clients"
          loading="lazy"
          width={900}
          height={377}
          className="mx-auto mt-2 block w-full max-w-5xl"
        />

        <div className="mt-0 bg-[#5C5C5C] px-6 py-6">
          <p className="text-center text-sm font-bold tracking-[0.2em] text-white md:text-base">
            BRAGGING RIGHTS
          </p>
          <ul className="mt-4 grid grid-cols-3 items-center justify-items-center gap-x-4 gap-y-4 sm:flex sm:flex-nowrap sm:justify-center sm:gap-x-5 md:gap-x-8 lg:gap-x-12">
            {PRESS_LOGOS.map((logo) => (
              <li key={logo.alt} className="flex items-center justify-center">
                <img
                  src={logo.src}
                  alt={logo.alt}
                  loading="lazy"
                  width={120}
                  height={48}
                  className="h-8 w-auto object-contain sm:h-8 md:h-10 lg:h-12"
                />
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}